import PageLayout from "../../layouts/PageLayout.tsx";
import { Card, SubCard } from "../../components/card/Card.tsx";
import EscrowsTables from "../../components/table/EscrowTables.tsx";
import { type Escrow, getEscrows } from "../../repository/EscrowRepository.ts";
import { useQuery } from "@tanstack/react-query";
import {
  EscrowState,
  getFormattedStatus,
} from "../../utils/getFormattedStatus.ts";

const EscrowList = () => {
  const { data: escrowList, isLoading: isEscrowListLoading } = useQuery({
    queryKey: ["escrows"],
    queryFn: async () => getEscrows(),
    select: (data) => {
      const activeEscrows: Escrow[] = [];
      const expiredEscrows: Escrow[] = [];
      const approvedEscrows: Escrow[] = [];

      data.forEach((escrow) => {
        switch (getFormattedStatus(escrow.status).state) {
          case EscrowState.ACTIVE:
          case EscrowState.AWAITING_PENALTIES:
            activeEscrows.push(escrow);
            break;
          case EscrowState.CANCELED:
            expiredEscrows.push(escrow);
            break;
          case EscrowState.APPROVED:
            approvedEscrows.push(escrow);
            break;
        }
      });

      return {
        activeEscrows,
        expiredEscrows,
        approvedEscrows,
      };
    },
  });

  if (!escrowList) {
    return null;
  }

  return (
    <PageLayout breadcrumbs={[{ name: "Escrow" }]}>
      <Card>
        <SubCard title="Active escrows">
          <EscrowsTables
            isLoading={isEscrowListLoading}
            escrows={escrowList.activeEscrows}
          />
        </SubCard>
        <SubCard title="Expired escrows">
          <EscrowsTables
            isLoading={isEscrowListLoading}
            escrows={escrowList.expiredEscrows}
          />
        </SubCard>
        <SubCard title="Approved escrows">
          <EscrowsTables
            isLoading={isEscrowListLoading}
            escrows={escrowList.approvedEscrows}
          />
        </SubCard>
      </Card>
    </PageLayout>
  );
};

export default EscrowList;
